import { http, HttpResponse } from "msw"
import type { ApiLabStocks } from "../../laboratoryStocks"
import { labStocksMock } from "./labStocks.mock"

const API_DOMAIN = import.meta.env.VITE_API_DOMAIN

export const financialDataLabStocks = [
  http.get(`${API_DOMAIN}/api/financial-data/laboratory/stock`, () =>
    HttpResponse.json<ApiLabStocks>(labStocksMock()),
  ),
  http.get(`${API_DOMAIN}/api/financial-data/laboratories/:labId/stock`, () =>
    HttpResponse.json<ApiLabStocks>(labStocksMock()),
  ),
]
